/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

/**
 * Notes service
 * @namespace NotesService
 * @description Service for display of notes
 */
! function() {
    "use strict";

    angular.module('webReader').service('LocalizationService', constructor);
    /**
     * @name Styles
     * @function
     * @description Creates or returns reference to singleton object that allows to work with this service
     * @returns {Object} - singleton service object
     * @memberof NotesService
     */
    function constructor(NetworkService, $cookieStore) {
        var self = this;
        var onLocalizationLoaded = [];
        var isLoaded = false;
        var localizationObject = {};
        var availableLanguages = { 'en-us': true, 'de-de': true, 'pt-br': true, 'ru-ru': true };
        var defaultLanguage = 'de-DE';
        var localization = localStorage.getItem('locale') || window.navigator.userLanguage || $cookieStore.get('COOKIE_LOCALE_LANG') || defaultLanguage;
        var targetLanguage = localization.substr(-2);
        // console.log(window.navigator.userLanguage, window.navigator.language, localStorage.getItem('locale'));

        localization = !!availableLanguages[localization.toLowerCase()] ? localization : defaultLanguage;
        // console.log(localization);
        self.executeSubscriptions = function(callbacks, args) {
            var self = this;
            return _.every(callbacks, function(fn) {
                if (!_.isNull(fn)) {
                    return fn.apply(self, [args]) !== false;
                }
            })
        };

        self.subscribe = {
            onLocalizationLoaded: function(callback) {

                onLocalizationLoaded.push(callback);
                isLoaded && self.executeSubscriptions.call(this, [callback], {});
            }
        };

        self.create = function() {
            //var localization = $cookieStore.get('COOKIE_LOCALE_LANG') || window.navigator.userLanguage || window.navigator.language;
            NetworkService.setTargetLanguage(targetLanguage);
            NetworkService.getLocalizationFile(localization).then(self.update).then(function() {
                isLoaded = true;
                self.executeSubscriptions.call(this, onLocalizationLoaded, {});
            });
        };

        self.getTargetLanguage = function() {
            return targetLanguage;
        };

        self.update = function(data) {
            localizationObject = data;
        };

        self.getTranslation = function(alias) {
            // console.log(localizationObject[alias])
            return localizationObject[alias] || '____';
        };

        self.getLanguage = function() {
            return targetLanguage;
        };

        self.create();

    }
    constructor.$inject = ["NetworkService", "$cookieStore"];
}();